import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=67373bde&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Message.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Message.vue
// module id = 1729
// module chunks = 1